/* ======================================================================== */
/* 31. sliderPortfolioItem */
/* ======================================================================== */
var SliderPortfolioItem = function ($scope) {

	var $slider = $scope.find('.js-slider-portfolio-item');

	createSlider();

	function createSlider() {

		if (!$slider.length) {
			return;
		}

		var
			lg = elementorFrontend.config.breakpoints.lg - 1 || 1024,
			md = elementorFrontend.config.breakpoints.md - 1 || 767;

		var
			slider = new Swiper($slider[0], {
				slidesPerView: $slider.data('slides-per-view') || 1,
				slidesPerGroup: 1, // compatibility with Swiper 5.x
				simulateTouch: false,
				autoplay: {
					enabled: $slider.data('autoplay-enabled') || false,
					delay: $slider.data('autoplay-delay') || 6000,
				},
				spaceBetween: $slider.data('space-between') || 0,
				centeredSlides: $slider.data('centered-slides') || false,
				autoHeight: true,
				speed: $slider.data('speed') || 800,
				pagination: {
					el: '.js-slider-portfolio-item-progress',
					type: 'progressbar',
					progressbarFillClass: 'slider__progressbar-fill',
					renderProgressbar: function (progressbarFillClass) {
						return '<div class="slider__progressbar"><div class="' + progressbarFillClass + '"></div></div>'
					}
				},
				navigation: {
					prevEl: '.js-slider-portfolio-item__arrow-left',
					nextEl: '.js-slider-portfolio-item__arrow-right',
				},
				watchSlidesProgress: true,
				breakpointsInverse: true, // compatibility with both Swiper 4.x and 5.x
				lazy: {
					loadPrevNextAmount: 2,
					loadPrevNext: true,
					loadOnTransitionStart: true
				}
			});

		slider.params.breakpoints = {
			[lg]: {
				slidesPerView: $slider.data('slides-per-view') || 1,
				spaceBetween: $slider.data('space-between') || 0,
				centeredSlides: $slider.data('centered-slides') || false,
			},
			[md]: {
				slidesPerView: $slider.data('slides-per-view-tablet') || 2,
				spaceBetween: $slider.data('space-between-tablet') || 0,
				centeredSlides: $slider.data('centered-slides-tablet') || 0,
			},
			0: {
				slidesPerView: $slider.data('slides-per-view-mobile') || 1,
				spaceBetween: $slider.data('space-between-mobile') || 0,
				centeredSlides: $slider.data('centered-slides-mobile') || 0,
			}
		};
		slider.update();

		renderSliderCounter(
			slider,
			$slider.find('.js-slider-portfolio-item-counter-current'),
			'',
			$slider.find('.js-slider-portfolio-item-counter-total')
		);

	}

}
